<template>
  <div>
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
      <div id="myCal">
        <!-- 保费试算 -->
        <div class="title_">
          <div class="cutleft_ order">保费试算</div>
          <div class="cutleft_ policy">险种信息</div>
          <div class="cutoff_"></div>
        </div>
        <a-row class="changeStyle_">
          <a-col :span="18">
            <div class="form_item" style="justify-content: flex-start">
              <label>保障期间</label>
              <div class="pre-box" style="margin-left: 10px">
                <div class="">
                  <a-radio-group
                    :disabled="disabledAll"
                    v-model="guapre"
                    @change="(e) => changeData(e.target.value, 'BZQJa')"
                  >
                    <a-radio
                      v-for="item in guarantPre"
                      :key="item.key"
                      :value="item.key"
                      >{{ item.value }}</a-radio
                    >
                  </a-radio-group>
                </div>
              </div>
            </div>
            <div class="order">
              <a @click="$tools.downloadFile(fileCodeContent.occ_url)">职业类别表</a>
            </div>
            <div class="form_item order">
              <label>投保职业</label>
              <div class="right_">
                <div
                  class="check_item s_input"
                  v-for="item in occupationNumberList"
                  :key="item.occupationKind"
                >
                  <label for>
                    {{ item.occupationKind }}
                  </label>
                  <a-input-number
                    :min="0"
                    :disabled="disabledAll"
                    v-model="item.personNum"
                    @change="(value) => changeData(value, 'TBZYa')"
                  ></a-input-number>
                  <span>人</span>
                </div>
                <div class="check_item">
                  <span>总人数：{{ totalNumber }}人</span>
                </div>
              </div>
            </div>
          </a-col>
          <a-col :offset="2" :span="4" class="calRight_ order">
            <div class="calTxt_">保费合计</div>
            <div class="calmoney_">¥ {{ premiumSum }}</div>
          </a-col>
        </a-row>
      </div>
      <div class="risk_">
        <p class="p-header">保障方案</p>
        <!-- 意外伤害身故、残疾 -->
        <div class="form_item">
          <label>保障方案选择</label>
          <div class="right_">
            <a-select
              :disabled="disabledAll"
              placeholder="请选择"
              style="width: 300px"
              class="select_"
              @change="(value) => changeData(value, 'plan')"
              v-model="countData.plan"
            >
              <a-select-option
                v-for="item in utils.plansValues"
                :key="item.value"
                :value="item.value"
                >{{ item.name }}</a-select-option
              >
            </a-select>
          </div>
        </div>
        <div class="form_item">
          <label>每次事故每人死亡/伤残责任限额</label>
          <div class="right_">
            <a-input
              :disabled="true"
              style="width: 300px"
              class="select_"
              v-model="planInfo.money"
            />
          </div>
        </div>
        <div class="form_item">
          <label>每次事故每人医疗费用责任限额</label>
          <div class="right_">
            <a-input
              :disabled="true"
              style="width: 300px"
              class="select_"
              v-model="planInfo.money1"
            />
          </div>
        </div>
        <div class="form_item">
          <label>误工费用</label>
          <div class="right_">
            <a-input
              :disabled="true"
              style="width: 300px"
              class="select_"
              v-model="planInfo.money2"
            />
          </div>
        </div>
        <div class="form_item">
          <label>附加扩展用工形式保险</label>
          <div class="right_">
            <a-input
              :disabled="true"
              style="width: 300px"
              class="select_"
              v-model="money3"
            />
          </div>
        </div>
        <p class="p-header">附加险</p>
        <div class="flex_">
          <!-- 附加24小时意外 -->
          <div class="form_item">
            <label>附加24小时意外</label>
            <div class="right_">
              <a-select
                :disabled="disabledAll"
                placeholder="请选择"
                style="width: 300px"
                class="select_"
                v-model="countData.FJ"
                @change="(value) => changeData(value, 'FJ')"
              >
                <a-select-option
                  v-for="(item, index) in utils.attendOptions"
                  :key="item.value + 'FJ' + index"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </div>
          </div>
          <!-- 拓展工伤十级10% -->
          <div class="form_item">
            <label>拓展工伤十级10%</label>
            <div class="right_">
              <a-select
                placeholder="请选择"
                style="width: 300px"
                class="select_"
                :disabled="disabledAll"
                v-model="countData.TZ"
                @change="(value) => changeData(value, 'TZ')"
              >
                <a-select-option
                  v-for="(item, index) in utils.extendOptions"
                  :key="item.value + 'TZ' + index"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </div>
          </div>
        </div>
        <div class="btn_list">
         <a-button style="margin-bottom:50px;" class="calBtn_" type="primary" @click="goplicy" v-if='!agreementRead'>
          完成报价，立即投保</a-button>
          <a-button
            class="calBtn_"
            :disabled="disabledAll"
            type="primary"
            @click="countPremiumSum"
            >刷新试算</a-button
          >
        </div>
      </div>
    </a-form>
  </div>
</template>

<script>
import { riskinfoMixin } from '@/mixins/riskinfoMixin.js';
import utils from '../data/index'
export default {
  mixins: [riskinfoMixin],
  data() {
    return {
      utils,
      productCode: "",
      plan: "",
      form: this.$form.createForm(this, { name: "advanced_search" }),
      guapre: 'MONTH_1',
      //保障期间
      guarantPre: utils.guarantPre,

      premiumSum: 0, //总保费
      // 测算要提交的数据
      countData: {
        plan: '1',
        FJ: 'N', //附加24小时意外
        TZ: 'N', //拓展工伤十级10%
      },
      money3: '附加',
      planInfo: {
        value: '1',
        name: '计划一',
        money: '10万',
        money1: '1万',
        money2: '100元/天',
        money3: '附加'
      },
      //提交data
      data: {
        salPolicy: {
          productCode: "", //产品code
          planCode: "",
        },
        salPolicyHolder: {
          addfifty: "1", // 测算类型
          planinfos: '1,N,N,MONTH,1', 
        },
        premiumBaseDtoList: [], //人数
      },
      planType: "A",
      occupationNumberList: [
        {
          occupationKind: "1类",
          personNum: 0,
        },
        {
          occupationKind: "2类",
          personNum: 0,
        },
        {
          occupationKind: "3类",
          personNum: 0,
        },
        {
          occupationKind: "4类",
          personNum: 0,
        },
      ],
    };
  },
  computed: {
    // 选的总投保人数
    totalNumber() {
      let num = 0;
      this.occupationNumberList.forEach((e) => {
        num += Number(e.personNum);
      });
      return parseInt(num);
    },
    // 险种的数组
    riskInfos() {
      let arr = []
      let infos = [
        {
          riskCode: "PL1800143", //意外伤害身故、残疾
          amount: this.countData.SWCJ,
          dutyCode: "CV63001",
          riskInfoName: "disabilityByAccident",
          premiumAmt:0,
          riskName:`意外伤害身故、残疾`,
          riskAmountDesc:this.countData.SWCJ
        },
       
        {
          riskCode: "PL180J136", //自费药费用
          amount: this.countData.ZFYF * this.countData.YLFY,
          dutyCode: "CVJA046",
          riskInfoName: "fullCostMedicine",
          premiumAmt:0,
          riskName:`自费药费用`,
          riskAmountDesc:this.countData.ZFYF * this.countData.YLFY
        },
        {
          riskCode: "selTag99", //扩展残疾鉴定国家工伤标准
          amount: this.countData.KZSC,
          dutyCode: "selTag99",
          riskInfoName: "disabilityAssessment",
          premiumAmt:0,
          riskName:`扩展残疾鉴定国家工伤标准`,
          riskAmountDesc:this.countData.KZSC?'按国家工伤与职业病标准':0
        },
        {
          riskCode: "PL1800144", //飞机意外伤害身故和残疾
          amount: this.countData.YCXSCa,
          dutyCode: "CV01659",
          riskInfoName: "accidentDisabilityByPlane",
          premiumAmt:0,
          riskName:`飞机意外伤害身故和残疾`,
          riskAmountDesc:this.countData.YCXSCa
        },
        {
          riskCode: "PL1800144", //火车意外伤害身故和残疾
          amount: this.countData.SHHLa,
          dutyCode: "CV01660",
          riskInfoName: "accidentDisabilityByTrain",
          premiumAmt:0,
          riskName:`火车意外伤害身故和残疾`,
          riskAmountDesc:this.countData.SHHLa
        },
        {
          riskCode: "PL1800144", //轮船意外伤害身故和残疾
          amount: this.countData.KYLCYW,
          dutyCode: "CV01661",
          riskInfoName: "accidentDisabilityByShip",
          premiumAmt:0,
          riskName:`轮船意外伤害身故和残疾`,
          riskAmountDesc:this.countData.KYLCYW
        },
        {
          riskCode: "PL1800144", //汽车意外伤害身故和残疾
          amount: this.countData.KYQCYW,
          dutyCode: "CV01662",
          riskInfoName: "accidentDisabilityByCar",
          premiumAmt:0,
          riskName:`汽车意外伤害身故和残疾`,
          riskAmountDesc:this.countData.KYQCYW
        },
        {
          riskCode: "PL1800276", //驾乘意外
          amount: this.countData.JCYW,
          dutyCode: "CV01845",
          riskInfoName: "accidentDisabilityByDriver",
          premiumAmt:0,
          riskName:`交通出行意外`,
          riskAmountDesc:this.countData.JCYW
        },
        {
          riskCode: "PL180J105", //猝死
          amount: this.countData.WGFY,
          dutyCode: "CVJB009",
          riskInfoName: "suddenDeath",
          premiumAmt:0,
          riskName:`猝死`,
          riskAmountDesc:this.countData.WGFY
        }
      ];
      arr =[{
        riskCode: "PL1800143", //意外伤害医疗
        amount: this.countData.YLFY,
        dutyCode: "CV02197",
        riskInfoName: "hospitalizationByAccident",
        premiumAmt:0,
        riskName:`意外伤害医疗费用（社保范围内100元免赔100%赔付）`,
        riskAmountDesc:this.countData.YLFY
      },
      {
        riskCode: "PL1800143", //意外伤害住院津贴
        amount: this.countData.ZYJT * 180,
        dutyCode: "CV01931",
        riskInfoName: "allowanceByAccident",
        premiumAmt:0,
        riskName:`意外伤害住院津贴`,
        riskAmountDesc:this.countData.ZYJT+'元/天'
      }] 
      return [...infos,...arr];
    },
    // 投保人名称限制
    nameFilter() {
      if (this.countData.name) {
        const nameFilter = /家具|木材|五金|金属|建筑|工程|实业|劳务|剪切|车床/
        if (nameFilter.test(this.countData.name)) {
          this.countData.KZSC = 0;
          
          return true;
        } else {
          
          return false;
        }
      } else {
          
        return false;
      }
    },
  },
  props: ["disabledAll"],
  created() {
    const {  p, planCode } = this.$route.query;
    this.productCode = p;
    this.plan = planCode;
    this.countPremiumSum("init");
  },
  mounted() {
    this.$bus.$on("busRiskInfos", (data) => {
      this.countData.planinfos = data.salPolicyHolder.planinfos || '1,N,N,MONTH,1'
      let planArr = this.countData.planinfos.split(',')
      if(planArr[3] === 'YEAR') {
        this.guapre = 'YEAR_12'
      } else {
        this.guapre = `${planArr[3]}_${planArr[4]||1}`
      }
      this.countData.plan = planArr[0]
      this.planInfo = this.utils.plansValues.find(item => item.value === planArr[0])
      this.countData.FJ = planArr[1]
      this.countData.TZ = planArr[2]
      this.changeData()
    });
  },
  beforeDestroy() {
    this.$bus.$off("busRiskInfos");
  },
  methods: {
      // 去投保
      goplicy() {
        this.$store.commit('setAgreement', true)
      },

    // 改变试算的数据
    changeData(value, param) {
      
      if (param=='plan') {
        this.planInfo = this.utils.plansValues.find(item => item.value === value)
      }
      this.countData[param] = value;
      let guapre = this.guapre.split('_')
      this.data = {
        salPolicy: {
          productCode: this.productCode, //产品code
          planCode: this.productCode,
        },
        salPolicyHolder: {
          addfifty: "1", // 测算类型
          planinfos: `${this.countData.plan},${this.countData.FJ},${this.countData.TZ},${guapre[0]},${guapre[1]}`
        },
        premiumBaseDtoList: this.occupationNumberList.filter(
          (item) => item.personNum > 0
        ), //人数
        // premiumBaseDtoList: this.occupationNumberList, //人数
      };
      let arrData = this.$lodash.cloneDeep(this.data);
      delete arrData["premiumBaseDtoList"]; //投保职业人数是不参与下面的计算的
      if (param != "TBZYa") {
        
        this.$bus.$emit("onRiskInfos", arrData);
      }
    },
    //保费试算
    countPremiumSum(type) {
      
      this.data.salPolicyHolder.addfifty = "1";
      this.form.validateFields((err) => {
        if (!err) {
          
          
          if (type != 'init') {
            if (!this.totalNumber) {
              this.$message.warning('请先选择投保人');
              return;
            }
          }
          if (type == "init") {
            this.data.riskInfos = this.riskInfos;
            this.data.salPolicy.productCode = this.productCode;
            this.data.salPolicy.planCode = this.productCode;
            return
          }

          this.$api.calPremiumEmployer(this.data).then((res) => {
            
            if (res.data.success) {
              let data = res.data.content;
              this.premiumSum = data.totalPremium;
              
              
              // this.$bus.$emit("CScontent", data);
            } else {
              this.$message.error(res.data.returnMsg + "错误");
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .policy {
    display: none;
  }

.calTxt_ {
  font-size: 18px !important;
  font-weight: bold !important;
  color: #666666;
}
.pre-box {
  margin-top: 15px;
}
.form_items {
  display: flex;
  width: 100%;
  color: #333;
  margin-bottom: 10px;
}
.risk_ {
  width: 60%;
}
.btn_list {
  margin-top: 20px;
  display: flex;

  .calBtn_ {
    margin-right: 30px;
  }
}
.flex_ {
  display: flex;
  flex-wrap: wrap;
}
.form_item {
  display: flex;
  justify-content: space-between;
  width: 100%;
  color: #333;
  margin-bottom: 10px;

  &.width_50 {
    width: 50%;
  }

  &.width_40 {
    width: 40%;
  }

  &.width_60 {
    width: 60%;
  }

  > label {
    white-space: nowrap;
    margin-right: 10px;
    margin-top: 15px;
  }

  .right_ {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;

    .select_ {
      margin-top: 10px;
    }

    .check_item {
      display: flex;
      align-items: center;
      margin-right: 10px;
      margin-top: 10px;

      &.on {
        label {
          border-color: #fe8f2d;
        }
      }

      label {
        // border: 1px solid #d9d9d9;
        padding: 3px 10px;
        border-radius: 3px;
        margin-right: 5px;
      }

      &.s_input input {
        width: 50px;
      }

      input {
        width: 150px;
        margin-right: 5px;
      }
    }
  }
}
.p-header {
  width: 100%;
  font-weight: bold;
  font-size: 15px;
  margin-bottom: 0;
}
.waring-color{
  font-size: 12px;
  color: #e6a23c;
}
.gsdiposition{
  width: 300px;
}
.gsdc-icon{
  margin: 3px 3px 0;
}
</style>